<template>
  <div class="d-flex flex-column ga-4">
    <select-resource
      v-if="!disabled.nutrientTableId"
      v-model="params.nutrientTableId"
      :error-messages="errors.get('params.nutrientTableId')"
      item-name="description"
      :label="$t('nutrient-tables.id')"
      name="nutrientTableId"
      resource="nutrient-tables"
    />
  </div>
</template>

<script lang="ts" setup>
import { SelectResource } from '@intake24/admin/components/dialogs';

import { createJobParamProps, useJobParams } from './use-job-params';

const props = defineProps(createJobParamProps<'NutrientTableMappingExport'>());

const emit = defineEmits(['update:modelValue']);

const { params } = useJobParams<'NutrientTableMappingExport'>(props, { emit });
</script>

<style scoped></style>
